import { getConfig } from '@superbet-group/web.lib.config';
import { differenceInHours } from '@superbet-group/web.lib.utilities';
import { Store } from 'vuex';

import { clientStorageWithExpiry } from '@core/clientStorage/clientStorageWithExpiry';
import ScheduledUtil from '@core/utils/scheduled/ScheduledUtil';
import {
    SESSION_START,
    LAST_SESSION_DURATION_SHOWN_DATE,
} from '@store/modules/data/authentication/authenticationIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

import { ScheduledJob } from '../types';

export function createSessionDurationJob(store: Store<any>): ScheduledJob {
    let jobId: number | null = null;

    function showSessionDurationModal() {
        const sessionStart = clientStorageWithExpiry.get<number>(SESSION_START);
        if (!sessionStart) {
            return;
        }

        const currentTime = Date.now();
        const hoursOnline = differenceInHours(currentTime, sessionStart);

        const lastSessionDurationShownDate = store.getters['data/authentication/lastSessionDurationShownDate'];

        if (hoursOnline && (!lastSessionDurationShownDate
            || differenceInHours(currentTime, lastSessionDurationShownDate))) {
            store.dispatch(
                'ui/modal/pushModal',
                {
                    code: modalCodes.sessionDuration,
                    data: {
                        hoursOnline: hoursOnline,
                    },
                    isUnique: true,
                },
                { root: true });

            clientStorageWithExpiry.set('user:lastSessionDurationShownDate', currentTime);
            store.commit(`data/authentication/${LAST_SESSION_DURATION_SHOWN_DATE}`, currentTime);
        }
    }

    return {
        start() {
            if (jobId) {
                return;
            }
            jobId = ScheduledUtil.scheduleTask(showSessionDurationModal, getConfig().countrySpecific.getSessionDuration);
        },
        destroy() {
            ScheduledUtil.removeScheduledTask(jobId!);
            jobId = null;
        },
    };
}
